































































import Vue from 'vue'
import Spinner from 'vue-simple-spinner';
import axios, { AxiosResponse } from 'axios'
import { cloudFunctionsBaseURL } from '../api/api';
import { firestore } from '../lib/firebase';
export default Vue.extend({
  name: 'EditorOutputSummary',
  components: { Spinner },
  props: {
    feedData: {
      type: Object,
      default: null
    },
    publicID: {
      type: String,
      default: ''
    },
    podpastSettings: {
      type: Object,
      default: null
    },
    sourceData: {
      type: Object,
      default: null
    }
  },
  data(): any {
    return {
      inProgress: false,
      recentlySaved: false,
      recentlySavedTimeout: null
    }
  },
  computed: {
    podpastRSSFeedURL(): string {
      return 'https://www.podspast.com/feed?id=' + this.publicID
    },
    uriEncodedPodpastRSSFeedURL(): string {
      return encodeURIComponent(this.podpastRSSFeedURL)
    }
  },
  methods: {
    postPodpast(isNew: boolean) {
      this.inProgress = true
      if (isNew) {
        firestore.collection('podpast').add({
          ...this.podpastSettings,
          ...this.sourceData
        })
          .then(doc => {
            this.inProgress = false
            this.$router.push({
              name: 'editor',
              params: {
                providedid: doc.id
              },
            })
          })
          .catch((error: Error) => {
            this.inProgress = false
            alert('Error occurred while saving, sorry!')
          })
      } else {
        firestore.collection('podpast').doc(this.publicID).update({
          ...this.podpastSettings,
          ...this.sourceData
        })
          .then(() => {
            this.$emit('updatePodpastSettings', {
              publicID: this.publicID,
              ...this.podpastSettings,
              ...this.sourceData // Not sure that this is the expected data
            })
            this.recentlySaved = true
            if (this.recentlySavedTimeout) {
              window.clearTimeout(this.recentlySavedTimeout)
            }
            this.recentlySavedTimeout = window.setTimeout(() => {
              this.recentlySaved = false
            }, 3000)
            this.inProgress = false
          })
          .catch((error: Error) => {
            this.inProgress = false
            alert('Error occurred while saving, sorry!')
          })
      }
    }
  }
})
